import { render, staticRenderFns } from "./TaskFields.vue?vue&type=template&id=20e24a2e&"
import script from "./TaskFields.vue?vue&type=script&lang=js&"
export * from "./TaskFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports